import React, { useContext, useEffect, useRef } from 'react';
import { makeStyles, SwipeableDrawer } from '@material-ui/core';
import cn from 'classnames';
import shadows from "../../foundations/shadows.module.scss";
import { ChevronLeft } from "../../icons";
import { useStateInRef } from "../../utils/useStateInRef";
import { CloseButton } from "../CloseButton/CloseButton";
import { IconButton } from "../IconButton";
import { useOverlayContext } from "../OverlayContext";
import styles from "./BottomSheet.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const IsIBottomSheetContext = /*#__PURE__*/React.createContext(false);
export const useIsInBottomSheet = () => useContext(IsIBottomSheetContext);
export const useBottomSheetStyles = makeStyles({
  paper: {
    borderRadius: '16px 16px 0 0',
    boxShadow: shadows.sh60,
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 'calc(100% - 48px)',
    height: 'auto'
  },
  paperForMobile: {
    height: 'intrinsic !important' // Fixes the height of the bottom sheet in iOS devices
  },
  backdrop: {
    backgroundColor: "rgba(0,0,0,0.2)"
  }
});
export function BottomSheet(props) {
  const {
    open,
    onClose,
    onOpen = () => {},
    children,
    showBackButton,
    onBack,
    onExited,
    paddingBottom = 16
  } = props;
  const getProps = useStateInRef(props);
  const {
    isTestMode
  } = useOverlayContext();
  const contentRef = useRef(null);
  const classes = useBottomSheetStyles();
  useEffect(() => {
    const disableSwipeIfInContent = e => {
      if (getProps().open && contentRef.current && e.target && contentRef.current.contains(e.target)) {
        // This tells MUI SwipeableDrawer to not handle the swipe.
        e['muiHandled'] = true;
      }
    };
    document.addEventListener('touchstart', disableSwipeIfInContent, true);
    return () => {
      document.removeEventListener('touchstart', disableSwipeIfInContent);
    };
  }, []);
  return /*#__PURE__*/_jsx(SwipeableDrawer, {
    disableDiscovery: true,
    disableSwipeToOpen: true,
    classes: {
      paper: cn(classes.paper, classes.paperForMobile)
    },
    anchor: "bottom",
    open: open,
    onClose: onClose,
    onOpen: onOpen,
    transitionDuration: isTestMode ? 0 : undefined,
    SlideProps: {
      onExited
    },
    ModalProps: {
      BackdropProps: {
        classes: {
          root: classes.backdrop
        }
      }
    },
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.root,
      style: {
        paddingBottom
      },
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.top,
        children: [showBackButton && /*#__PURE__*/_jsx("div", {
          className: styles.backButton,
          children: /*#__PURE__*/_jsx(IconButton, {
            noPadding: true,
            onClick: onBack,
            size: "small",
            "data-testid": "bottom-sheet-back-button",
            children: /*#__PURE__*/_jsx(ChevronLeft, {})
          })
        }), /*#__PURE__*/_jsx("div", {
          className: styles.swipeIndicator
        }), /*#__PURE__*/_jsx(CloseButton, {
          noPadding: true,
          className: styles.closeButton,
          size: "small",
          onClick: onClose,
          "data-testid": "bottom-sheet-close-button"
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: styles.content,
        ref: contentRef,
        children: /*#__PURE__*/_jsx(IsIBottomSheetContext.Provider, {
          value: true,
          children: children
        })
      })]
    })
  });
}